import React from "react";
import { CustodianDetails } from "../../../containers";

const CustodianDetail = (props) => {
  return <CustodianDetails {...props} />;
};

export default CustodianDetail;
